module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/T-Shirt-cc656fffd50ad0f986f52cb629a6aeec.svg";